export default __webpack_public_path__ + "static/media/car.64f517a6.svg";